import NotificationTransactionDecrement from "@/domains/notifications/components/NotificationsTransactionDecrement";
import NotificationTransactionIncrement from "@/domains/notifications/components/NotificationsTransactionIncrement";

type Props = {
  image: string;
  isIncrement: boolean;
  value: number;
  text: string;
  title: string | null;
};

export default function NotificationTransactionBody({
  image,
  isIncrement,
  value,
  text,
  title,
}: Props) {
  const Components = isIncrement
    ? NotificationTransactionIncrement
    : NotificationTransactionDecrement;
  return (
    <div className="relative w-[16.875rem] bg-gradient-to-r from-dark-900/60 to-dark-900/80 rounded-xl overflow-hidden pointer-events-auto">
      <Components image={image} value={value} text={text} title={title} />
    </div>
  );
}
